import {
    apiRequest,
    koreksiKehadiranList,
    koreksiKehadiranInactive
} from '../../../../../../services/adapters/kepegawaian/koreksiKehadiranService'

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", koreksiKehadiranList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    
    fetchInactive = async (query) => {
        return await apiRequest("post", koreksiKehadiranInactive, {
            body: query
        }, true)
    }
}

export default DataTableRepository